package one.healthium.onboarding.domain.screens

import kotlinx.serialization.Contextual
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.Color

@Serializable
data class OnboardingGlobalScreenConfig(
    @SerialName("color_theme") val colorTheme: String? = null,
    @SerialName("progress_colors") val progressColors: List<@Contextual Color> = emptyList(),
    @SerialName("progress_bg") @Contextual val progressBackground: Color? = null,
)